module.exports = __webpack_public_path__ + "static/media/Santa Clara Street, Brisbane, CA8.f4ad7fb1.jpg";